var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.82 581.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.66,499.93v33.49h-31.63c.36-11.21,.38-20.94-.11-29.36-1.82-31.38-10.77-44.54-36.26-48.23-2.83-.42-5.87-.71-9.12-.9-5.39-.31-11.38-.34-18.03-.13-6.65-.21-12.63-.18-18.03,.13h-40.48c-8.87-.37-16.63-.37-23.4,.12-38.98,2.8-45.58,21.73-43.7,79.04v47.14h-31.72v-81.3c0-43.71,29.27-73.04,72.92-73.04h106.65c1.66,0,3.29,.04,4.91,.13,23.75,1.22,42.82,11.39,54.66,27.91,.03,.03,.05,.07,.08,.11,8.54,11.97,13.28,27.26,13.26,44.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M407.27,313.75c-.07-.21-.16-.41-.24-.62-1.93-4.75-4.3-9.18-7.05-13.27-7.36-10.94-17.43-19.42-28.91-24.88-17.7-8.43-38.75-9.68-58.35-1.72-11.4,4.82-21.1,12.35-28.49,21.65-9.95,12.53-15.7,28.3-15.71,44.99,0,2.37,.11,4.72,.33,7.03,3.52,36.69,34.42,65.39,72.04,65.42,9.67,.01,19.24-1.93,28.15-5.7,.96-.42,1.91-.87,2.85-1.34,10.65-5.22,19.5-12.76,26.17-21.76,.84-1.13,1.64-2.28,2.4-3.45,12.5-19.06,15.79-43.66,6.81-66.35Zm-35.33,51.76c-6.99,8.5-17.4,14.07-29.12,14.62-.64,.03-1.28,.05-1.93,.05-19.99,0-36.58-14.59-39.69-33.7-.35-2.12-.53-4.3-.53-6.52,0-22.21,18.01-40.22,40.22-40.22,.64,0,1.27,.02,1.9,.05,11.73,.56,22.14,6.13,29.15,14.63,5.72,6.94,9.16,15.84,9.17,25.54,0,7.05-1.81,13.68-5.01,19.44h0c-1.2,2.18-2.59,4.21-4.16,6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.52,339.9c0,2.37,.11,4.72,.33,7.03h-85.54c-110.96-4.66-128.57,22.03-124.48,146.85v87.45H0v-150.82c0-81.1,54.29-135.5,135.27-135.5h148.96c-9.95,12.53-15.7,28.3-15.71,44.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3-2",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "560.82 518.75 540.06 539.51 498.91 580.65 478.15 559.89 504.62 533.42 331.09 533.42 331.09 504.06 504.61 504.06 478.15 477.6 498.91 456.84 560.82 518.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnResponsive);
export default __webpack_public_path__ + "static/media/unResponsive.dcc3642d6b37b9344f4a2269f19052a3.svg";
export { ForwardRef as ReactComponent };